export default {
  //* DXP MOCK
  DOWNLOAD_DOCUMENT_BY_REFERENCE: '/Document/DownloadDocumentByReference.json',
  SAVE_QUOTATION: '/Save/SaveQuotation.json',
  SAVE_QUOTATION_DENTAL: '/Quotation/SaveDental.json',
  RATER_CALCULATE_PRICE: '/Pricing/GetPricing.json',
  RATER_CALCULATE_PRICE_DENTAL: '/Pricing/GetPricingDental.json',
  SEND_BUDGET: '/Email/SendEmailBudget.json',
  CLICK_TO_CALL: '/ClickToCall/ClickToCall.json',
  AUTOCOMPLETE_CITY: '/Normalice/AutocompleteZip.json',
  GET_POSTAL_CODES: '/PostalCode/GetCP.json',
  POST_CP_CODES: '/Normalice/AutocompleteZip.json'
}
// TODO: revisar nuevos endpoints